import type { ReactNode } from "react";

interface HeroProps {
  eyebrow?: string;
  title: ReactNode;
  subtitle?: string;
  actions?: ReactNode;
  decoration?: ReactNode;
}

export function Hero({
  eyebrow,
  title,
  subtitle,
  actions,
  decoration,
}: HeroProps) {
  return (
    <section className="relative overflow-hidden pt-36 pb-20 md:pt-44 md:pb-28 px-6">
      <div className="grain" />
      <div className="pointer-events-none absolute inset-0 grid-bg text-foreground/[0.06]" />

      <div className="relative mx-auto max-w-7xl grid md:grid-cols-[1.1fr_0.9fr] gap-16 items-center">
        <div>
          {eyebrow && (
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-foreground/15 bg-card px-4 py-1.5 text-xs font-mono uppercase tracking-[0.16em] text-muted-foreground ticket-shadow">
              <span className="h-1.5 w-1.5 rounded-full bg-primary" />
              {eyebrow}
            </div>
          )}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.02] text-foreground max-w-xl">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-7 max-w-md text-lg leading-relaxed text-muted-foreground">
              {subtitle}
            </p>
          )}
          {actions && (
            <div className="mt-10 flex flex-wrap items-center gap-4">
              {actions}
            </div>
          )}
          <div className="mt-14 max-w-sm text-foreground/50">
            <div className="barcode-rule" />
          </div>
        </div>

        {decoration && (
          <div className="relative hidden md:block h-[26rem]">{decoration}</div>
        )}
      </div>
    </section>
  );
}
